import { Assets } from './Assets'
import { selectData } from 'layouts/onboarding'
export const Deductions = ({ deductions, handleOnClick }) => {
  const { deductionTypes } = selectData
  const deductionWithLabelAsName = (deductions || [])
    .filter((option) => option.type === Deductions.targetCategory)
    .map((deduction) => ({
      ...deduction,
      name: deductionTypes.find(({ value }) => value === deduction.subType)
        ?.label,
    }))
  return (
    <Assets
      assets={deductionWithLabelAsName}
      handleOnClick={handleOnClick}
      category={Deductions.targetCategory}
    />
  )
}
Deductions.targetCategory = 'deduction'
